module.exports = __webpack_public_path__ + "img/effect_voices_from_below.113582ec.png";